import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resourcesToBackend from "i18next-resources-to-backend";

const i18nInstance = i18n
	.use(initReactI18next) // passes i18n down to react-i18next
	.use(
		resourcesToBackend((language: any, namespace: any) => {
			return import(`./${language}/${namespace}.json`).catch(() => {
				console.warn(
					`Translation file not found: ${language}/${namespace}.json, falling back to common`
				);
				return import(`./${language}/common.json`);
			});
		})
	);

// Initialize i18n and return a promise
const i18nPromise = i18nInstance.init({
	lng: "he",
	fallbackLng: "he",
	defaultNS: "common",
	ns: ["common", "admin", "profile", "home", "requestDetailsPage", "doctorTemplates", "doctorProfile"],
	fallbackNS: "common",
	// Disable language detection to ensure we always use 'he'
	detection: {
		order: [],
		caches: [],
	},

	interpolation: {
		escapeValue: false, // react already safes from xss
	},
	react: {
		useSuspense: false,
	},
	// debug: import.meta.env.DEV, // Enable debug in development
});

// Add event listeners for debugging
i18n.on("initialized", () => {
	console.log("i18n initialized successfully");
});

i18n.on("loaded", () => {
	console.log("i18n loaded successfully");
});

i18n.on("failedLoading", (lng, ns, msg) => {
	console.error(`Failed to load translation: ${lng}/${ns}`, msg);
});

// Export a function to check if i18n is ready
export const isI18nReady = () => i18n.isInitialized;

// Export the promise for waiting
export const waitForI18n = () => i18nPromise;

export default i18n;
